import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { logout } from './../../app/slice/authSlice'
import { getAuthProps } from '../../lib/authenticationLibrary';
import { generateRequestSignature } from '../RequestSigning';

const { Mutex } = require('async-mutex');

const mutex = new Mutex();
const IsProdMode = false
// export const APIUrl = "https://localhost:7094/api/"; 
export const APIUrl = "https://aispprodapi.flyingcapetech.com/api/";

const baseQuery = fetchBaseQuery({
    baseUrl: APIUrl,
    prepareHeaders: (headers, { endpoint }) => {
        const UPLOAD_ENDPOINTS = ["uploadPDF"];

        if (!UPLOAD_ENDPOINTS.includes(endpoint)) {
            headers.set("Content-Type", "application/json");
        }

        const authData = getAuthProps();

        if (authData) {
            const token = authData.token.token;

            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
        }

        return headers;
    }
});


export const defautBaseQuery = async (args, api, extraOptions) => {
debugger
    // Get the actual request URL
    const url = typeof args === "string"
        ? args
        : args.url;

    // Build full URL using APIUrl
    const fullUrl = new URL(url, APIUrl);

    // Same format as your old Axios interceptor:
    // /api/Controller/Method?param=value
    const endpoint =
        fullUrl.pathname +
        fullUrl.search;

    // Generate fresh signature for EVERY request
    const {
        timestamp,
        nonce,
        signature
    } = generateRequestSignature(endpoint);

    // Add signature headers
    if (typeof args === "string") {

        args = {
            url: args,
            headers: {
                "X-Timestamp": timestamp,
                "X-Nonce": nonce,
                "X-Signature": signature
            }
        };

    } else {

        args = {
            ...args,
            headers: {
                ...(args.headers || {}),
                "X-Timestamp": timestamp,
                "X-Nonce": nonce,
                "X-Signature": signature
            }
        };
    }

    return baseQuery(args, api, extraOptions);
};


export const fileUploadQuery = fetchBaseQuery({
  baseUrl: APIUrl,
  prepareHeaders: (headers) => {

    const boundary = `---------------------------${Math.floor(Math.random() * 1000000000000000)}`;

    headers.set("Content-Type", `multipart/form-data; boundary=${boundary}`);
    let authData = getAuthProps();
    let token = null;
    if (authData) {
      token = authData.token.token;
      headers.set("Authorization", `Bearer ${token}`);
    }

    // if (!token) {
    //   // dispatch(logout());
    //   window.location.href = '/login'
    //   return;
    // }

    return headers;
  }
})


export const customFetchBase = async (args, api, extraOptions) => {
    const authData = getAuthProps();
    let token = null;
    if (authData)
        token = authData.token.token;

    if (!token) {
        window.location.href = '/login';
        return;
    }

    await mutex.waitForUnlock();

    // -----------------------------------------
    // Get actual request URL
    // -----------------------------------------

    const url = typeof args === "string"
        ? args
        : args.url;

    const fullUrl = new URL(url, APIUrl);

    // Example:
    // /api/Controller/Method?param=value
    const endpoint =
        fullUrl.pathname +
        fullUrl.search;


    // -----------------------------------------
    // Generate fresh signature
    // -----------------------------------------

    const {
        timestamp,
        nonce,
        signature
    } = generateRequestSignature(endpoint);


    // -----------------------------------------
    // Add Authorization + Signature headers
    // -----------------------------------------

    if (typeof args === "string") {

        args = {
            url: args,
            headers: {
                Authorization: `Bearer ${token}`,
                "X-Timestamp": timestamp,
                "X-Nonce": nonce,
                "X-Signature": signature
            }
        };

    } else {

        args = {
            ...args,

            headers: {
                ...(args.headers || {}),

                Authorization: `Bearer ${token}`,

                "X-Timestamp": timestamp,
                "X-Nonce": nonce,
                "X-Signature": signature
            }
        };
    }

    args.headers = {
        ...args.headers,
        Authorization: `Bearer ${token}`,
    };

    let result = await baseQuery(args, api, extraOptions);

    if (result.error) {
        if (result.error.status === 401) {
            window.location.href = '/login';
        }
    }
    return result;
}


